// Som de notificação simples usando Web Audio API
export const playNotificationSound = () => {
  try {
    // Criar contexto de áudio
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    
    // Criar oscilador para gerar um beep simples
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // Configurar o som
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // Configurar frequência e volume
    oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // 800Hz
    oscillator.type = 'sine';
    
    // Configurar envelope de volume
    gainNode.gain.setValueAtTime(0, audioContext.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
    
    // Tocar o som
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
    
    // Limpar recursos
    setTimeout(() => {
      oscillator.disconnect();
      gainNode.disconnect();
    }, 300);
    
  } catch (error) {
    console.log('Erro ao tocar som de notificação:', error);
    
    // Fallback: tentar usar HTML5 Audio
    try {
      const audio = new Audio();
      audio.src = 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYIG2m98OScTgwOUarm7blmGgU7k9n1unEiBC13yO/eizEIHWq+8+OWT';
      audio.volume = 0.3;
      audio.play().catch(() => {
        console.log('Fallback de áudio também falhou');
      });
    } catch (fallbackError) {
      console.log('Fallback de áudio falhou:', fallbackError);
    }
  }
};

// Função para verificar se o navegador suporta áudio
export const isAudioSupported = () => {
  return !!(window.AudioContext || (window as any).webkitAudioContext);
};
